module.exports = __webpack_public_path__ + "img/hard-acceleration.8b2d0b52.png";